'use client'
import * as React from 'react'
import PublicViewPageTemplate from './Template'

type PublicViewPageProps = {}

// export const metadata = {
//   title: {
//     default: 'Visualização pública de documento',
//     template: `%s | Visualização pública de documento`,
//   },
// }

export default function PublicViewPage(props: PublicViewPageProps) {
  return <PublicViewPageTemplate />
}
